import { render } from "./LeadershipShow.vue?vue&type=template&id=2c0f96b0"
import script from "./LeadershipShow.vue?vue&type=script&lang=js"
export * from "./LeadershipShow.vue?vue&type=script&lang=js"

import "./LeadershipShow.vue?vue&type=style&index=0&id=2c0f96b0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__